export default __webpack_public_path__ + "static/media/icon-boletim-venda.087f8aa7.png";